/**
 * Environment Variables Verification
 * Checks that all required environment variables are available
 */

const requiredEnvVars = [
  'REACT_APP_API_ENDPOINT',
  'REACT_APP_SITE_KEY',
  'REACT_APP_IMAGE_URL'
];

/**
 * Validates all required environment variables are present
 * @returns {Object} - { isValid: boolean, missing: string[], errors: string[] }
 */
export function validateEnvVariables() {
  const missing = [];
  const errors = [];

  requiredEnvVars.forEach(varName => {
    const value = process.env[varName];
    
    if (!value || value.trim() === '') {
      missing.push(varName);
    } else {
      // Additional validation
      if (varName === 'REACT_APP_API_ENDPOINT') {
        try {
          new URL(value);
        } catch (e) {
          errors.push(`${varName} is not a valid URL: ${value}`);
        }
      }
      
      if (varName === 'REACT_APP_IMAGE_URL') {
        try {
          new URL(value);
        } catch (e) {
          errors.push(`${varName} is not a valid URL: ${value}`);
        }
      }
    }
  });

  const isValid = missing.length === 0 && errors.length === 0;

  if (!isValid) {
    console.error('❌ Environment Variables Validation Failed:');
    if (missing.length > 0) {
      console.error('Missing variables:', missing.join(', '));
    }
    if (errors.length > 0) {
      console.error('Validation errors:', errors.join(', '));
    }
  } else {
    console.log('✅ All required environment variables are present and valid');
    console.log('Environment variables:');
    requiredEnvVars.forEach(varName => {
      const value = process.env[varName];
      // Mask sensitive values (only show first few characters)
      const displayValue = varName === 'REACT_APP_SITE_KEY' 
        ? `${value.substring(0, 10)}...` 
        : value;
      console.log(`  ${varName}: ${displayValue}`);
    });
  }

  return {
    isValid,
    missing,
    errors,
    envVars: requiredEnvVars.reduce((acc, varName) => {
      acc[varName] = process.env[varName];
      return acc;
    }, {})
  };
}

/**
 * Validates and throws if any required variables are missing
 * Use this in development to fail fast if env vars are not set
 */
export function requireEnvVariables() {
  const validation = validateEnvVariables();
  
  if (!validation.isValid) {
    throw new Error(
      `Missing or invalid environment variables. Missing: ${validation.missing.join(', ')}. ` +
      `Errors: ${validation.errors.join(', ')}`
    );
  }
  
  return validation.envVars;
}

export default validateEnvVariables;

